import React from "react";
import { Link } from "react-router-dom";

const ReportCard = ({ name, status, compact = false }) => {
  const isAvailable = status === "available";

  return (
    <div
      className={`flex flex-col items-center text-center rounded-xl shadow-md transition transform hover:scale-105 ${
        isAvailable
          ? "bg-green-50 border border-green-200"
          : "bg-gray-100 border border-gray-200 opacity-70"
      } ${compact ? "px-4 py-3" : "p-6"}`}
    >
      <h4 className={`${compact ? "text-sm" : "text-lg"} font-semibold text-gray-800`}>
        {name}
      </h4>

      {isAvailable ? (
        <Link
          to="/signup"
          className={`mt-2 inline-block font-semibold rounded-full transition ${
            compact
              ? "bg-green-600 text-xs text-white px-3 py-1 hover:bg-green-700"
              : "bg-green-600 text-sm text-white px-4 py-2 hover:bg-green-700"
          }`}
        >
          {compact ? "Access Now" : "Access Report"}
        </Link>
      ) : (
        <span className={`${compact ? "text-xs" : "text-sm"} mt-2 text-gray-500`}>
          Coming Soon ⏳
        </span>
      )}
    </div>
  );
};

export default ReportCard;
